import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-spinner',
  standalone: true,
  imports: [],
  templateUrl: './loader-spinner.component.html',
  styleUrls: ['../../_styles/index.scss', './loader-spinner.component.scss'],
})
export class LoaderSpinnerComponent {
  @Input() message: string = 'Loading...';
}
